export default __webpack_public_path__ + "static/media/UploadIcon.4745687c.svg";